/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ device: NonNullable<unknown> }} Account_Audit_Last_DeviceInputs */

const fr_account_audit_last_device = /** @type {(inputs: Account_Audit_Last_DeviceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernier appareil : ${i?.device}`)
};

/**

* @param {Account_Audit_Last_DeviceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_last_device = /** @type {((inputs: Account_Audit_Last_DeviceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Last_DeviceInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_last_device(inputs)
});